import { DesignSystem } from '@bounty/creators-common/screens/design-system'
import { ReactElement } from 'react'
import { Layout } from '../Layout'
import { withSEO } from '../withSEO'
import { NextPageWithLayout } from './_app'

const Page: NextPageWithLayout = withSEO(DesignSystem)

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>
}

export default Page
